import { token } from 'services/LocalStorage/localStorage';
import { network } from 'services/network';

import { QueryParams } from 'api/queries/getAccessToken.query';

export const getUuid = (params: QueryParams) => {
    const uuid = params.uuid;
    const ssoType = params.ssoType;

    const url = `api/bo/${ssoType === 'OKTA' ? 'getUuidOkta' : 'getUuid'}?uuid=${uuid}`;
    return network.get(url).then((response) => {
        token.set(response.data.attribute);
        network.defaults.headers.common['Authorization'] = `Bearer ${response.data.attribute}`;
        return {
            username: response.data.username,
        };
    });
};
